import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { InputNumber } from "primereact/inputnumber";

export default function ProductTemperaturePromptModal(props) {
  const {
    setOpen,
    orderItem,
    order_id,
    setProductTemperature,
    onConfirm,
    showErrorModal,
  } = props;

  const [temperature, setTemperature] = useState(null);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setError("");
    const value = temperature ?? (temperature === 0 ? 0 : null);
    if (
      value === null ||
      value === undefined ||
      (typeof value === "number" && isNaN(value))
    ) {
      setError("Please enter a product temperature.");
      return;
    }

    setSubmitting(true);
    const result = await setProductTemperature(
      orderItem.product_id,
      value,
      order_id,
    );
    setSubmitting(false);

    if (result?.success) {
      onConfirm(value);
      setOpen({ childComponent: null, open: false });
    } else {
      showErrorModal?.(
        result?.data?.message || "Failed to set product temperature.",
      );
    }
  };

  const handleCancel = () => {
    setOpen({ childComponent: null, open: false });
  };

  return (
    <div>
      <div className="mt-3 text-center sm:mt-5">
        <Dialog.Title
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Product temperature not set
        </Dialog.Title>
        <p className="mt-2 text-sm text-gray-500">
          Please enter product temperature (°C) for{" "}
          {orderItem?.product_name || "this item"}.
        </p>
        <div className="mt-4 text-center">
          <label className="block text-sm font-medium text-gray-700">
            Product temperature (°C)
          </label>
          <InputNumber
            value={temperature}
            onValueChange={(e) => {
              setTemperature(e.value);
              setError("");
            }}
            minFractionDigits={0}
            maxFractionDigits={1}
            placeholder="°C"
            className="mt-1 block w-full"
            disabled={submitting}
          />
          {error && (
            <p className="mt-1 text-sm text-red-500 font-semibold">{error}</p>
          )}
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex flex-wrap gap-3 justify-center">
        <button
          type="button"
          className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          onClick={handleCancel}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600"
          onClick={handleConfirm}
          disabled={submitting}
        >
          {submitting ? "Saving..." : "Confirm"}
        </button>
      </div>
    </div>
  );
}
